import React, { createContext, useContext, useEffect, useState } from 'react';
import { apiUrl } from '../utils/config';

// Defaults are only used during the first render before the rates load.
const DEFAULT_RATES = { EUR: 0.0285, USD: 0.0312 };

const FxRatesContext = createContext({
  rates: DEFAULT_RATES,
  loaded: false,
  fetchedAt: null,
});

export const FxRatesProvider = ({ children }) => {
  const [rates, setRates] = useState(DEFAULT_RATES);
  const [loaded, setLoaded] = useState(false);
  const [fetchedAt, setFetchedAt] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetch(apiUrl('fx/rates'))
      .then((r) => r.json())
      .then((data) => {
        if (cancelled) return;
        if (data && data.rates && data.rates.EUR && data.rates.USD) {
          setRates({ EUR: data.rates.EUR, USD: data.rates.USD });
          setFetchedAt(data.fetched_at || null);
        }
        setLoaded(true);
      })
      .catch(() => {
        if (!cancelled) setLoaded(true);
      });
    return () => { cancelled = true; };
  }, []);

  return (
    <FxRatesContext.Provider value={{ rates, loaded, fetchedAt }}>
      {children}
    </FxRatesContext.Provider>
  );
};

export const useFxRates = () => useContext(FxRatesContext);

/**
 * Convert a TRY amount to a target currency using the loaded rate.
 * Returns 0 if the amount or rate is invalid.
 */
export const convertFromTRY = (tryAmount, rate) => {
  const n = Number(tryAmount);
  const r = Number(rate);
  if (!Number.isFinite(n) || !Number.isFinite(r) || r <= 0) return 0;
  return n * r;
};

/**
 * Round to 0 decimals for clean display ("~€72" instead of "~€71.50").
 */
export const formatEstimate = (value, locale = 'en-US') => {
  if (!Number.isFinite(value) || value <= 0) return '';
  return Math.round(value).toLocaleString(locale);
};
